const LANGUAGES = [
  { label: "English", code: "en", flag: "us" },
  { label: "Japan", code: "jp", flag: "jp" },
  { label: "China", code: "cn", flag: "cn" },
  { label: "Korea", code: "kr", flag: "kr" }
];

export default LANGUAGES;
